/** @typedef {import('../state').ExportTemplateState} ExportTemplateState */

/**
 * A POST request to set the favourite template has succeeded.
 * @param {ExportTemplateState} state
 * @param {number} payload
 */
export const favouriteTemplateSet = (state, payload) => ({
  ...state,
  favouriteTemplateId: payload,
  isFavouriteLoading: false,
});

/**
 * A POST request to set the favourite template has failed.
 * @param {ExportTemplateState} state
 */
export const favouriteSettingFailed = state => ({
  ...state,
  isFavouriteLoading: false,
});

/**
 * A POST request to set the favourite template has been made.
 * @param {ExportTemplateState} state
 */
export const favouriteSettingRequested = state => ({
  ...state,
  isFavouriteLoading: true,
});
